<template>
  <b-dropdown  size="sm">
    <template slot="button-content">
      <i class="fas fa-bars"></i>
    </template>
    <template v-for="item in dropdownList">
      <b-dropdown-item :key="item.id" :to="{path: item.link + data.item.id}"><i :class="item.icon"></i> {{ item.text }}</b-dropdown-item>
    </template>
  </b-dropdown>
</template>

<script>
  export default {
    name: 'dropdownList',
    props: {
      dropdownList: {
        type: Array,
        required: true
      },
      data: {
        required: true
      }
    }
  }
</script>
